module.exports = __webpack_public_path__ + "img/star.1ad8cc5.png?v=1791296779994";